import { render, staticRenderFns } from "./BizTaskNotifyMeModal.vue?vue&type=template&id=48af0c6f&scoped=true&"
import script from "./BizTaskNotifyMeModal.vue?vue&type=script&lang=js&"
export * from "./BizTaskNotifyMeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af0c6f",
  null
  
)

export default component.exports